import { merge } from 'lodash';

import { ICustomer } from 'shared/domain/entities';

const removeMaskPlaceholder = (value?: string) => value?.replace(/_/g, '');

export default function buildCustomerUpdateBody(
  customer: Partial<ICustomer>,
  values: Partial<ICustomer>,
): Partial<ICustomer> {
  const hasGuardian = Boolean(customer.guardian || values.guardian);

  return merge(
    {},
    { address: customer.address, guardian: customer.guardian },
    values,
    {
      document: removeMaskPlaceholder(values.document),
      ...(hasGuardian
        ? {
            guardian: {
              document: removeMaskPlaceholder(values.guardian?.document),
            },
          }
        : {}),
    },
  );
}
